// extracted by mini-css-extract-plugin
export var modal = "_g9-0";